import { render } from "./ProfileAndSettingsPage.vue?vue&type=template&id=138421f6"
import script from "./ProfileAndSettingsPage.vue?vue&type=script&lang=js"
export * from "./ProfileAndSettingsPage.vue?vue&type=script&lang=js"
script.render = render

export default script